<template>
  <hm-content title="商品列表" class="micro-goods-list">
    <div class="table-panel flex flex-between flex-wrap">
      <div class="mr10">
        <el-button type="primary" size="small" @click="addGoods"
          >发布商品</el-button
        >
      </div>
      <div class="flex text-right item-center flex-wrap">
        <el-cascader
          v-model="searchCondition.categoryId"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="categoryFunc"
          clearable
          placeholder="请选择类目"
        ></el-cascader>
        <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入货号/条码/商品名/品牌"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output(allMallGoodsList, 'attrTable', '商品属性列表')"
          :loading="isOutputing"
          >导出</el-button
        >
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="flex batch flex-end">
        <div @click="batchSetting">
          <span class="delete-icon hmicon icon-xitong"></span>
          批量上架
        </div>
        <!-- <div @click="batchDelete">
          <span class="delete-icon hmicon icon-shanchu"></span>删除
        </div> -->
      </div>
      <el-table
        stripe
        border
        ref="brandTable"
        @selection-change="getChecked"
        :data="mallGoodsList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="商品名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="组合明细"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="访问量">
          <template slot-scope="scope">
            <span>人数：{{ scope.row.id }}人，次数：23次</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="组合售价"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="商品分类"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="salesState"
          label="上架状态"
        >
          <template slot-scope="scope">
            <span
              class="status danger"
              v-show="scope.row.salesState === 'close'"
              >下架</span
            >
            <span
              class="status success"
              v-show="scope.row.salesState === 'open'"
              >上架</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <div class="pointer mr10" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="推广" placement="top">
                <div class="pointer mr10" @click="edit(scope.row)">
                  <span class="hmicon icon-tuiguangqingkuang primary"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="复制" placement="top">
                <div class="pointer mr10" @click="copy(scope.row)">
                  <span class="hmicon icon-fuzhi purple"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="mallGoodsList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="批量设置"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <div class="mb20">已选商品数量{{ checkedRow.length }}</div>
      <div class="flex tabs">
        <el-form label-width="100px">
          <el-tabs tab-position="left">
            <el-tab-pane label="商品名称">
              <div class="first-tip">
                <div class="title">替换名称</div>
                <span class="form-item-tip"
                  >将商品名称中的文字替换成其他文字，“替换为”内容为空时，则将原有文字删除</span
                >
              </div>
              <el-form-item label="原有文字">
                <el-input
                  size="small"
                  type="text"
                  v-model="batchCondition.oldWord"
                ></el-input>
              </el-form-item>
              <el-form-item label="替换为">
                <el-input
                  size="small"
                  type="text"
                  v-model="batchCondition.newWord"
                ></el-input>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="商品分类">
              <el-form-item label="修改分类为">
                <el-cascader
                  v-model="batchCondition.categoryId"
                  :show-all-levels="false"
                  size="small"
                  class="mr10"
                  :props="categoryFunc"
                  clearable
                  placeholder="请选择类目"
                ></el-cascader>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="可售门店">
              <el-form-item label="可销售门店">
                <el-select
                  clearable
                  multiple
                  v-model="batchCondition.spuPlatFormList"
                  placeholder="请选择可销售门店"
                  size="small"
                  filterable
                  class="mr10"
                >
                  <el-option
                    :label="v.platformName"
                    :value="v.platformId"
                    v-for="(v, i) in salesChannels"
                    :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="配送方式">
              <el-form-item label="配送方式">
                <el-select
                  clearable
                  multiple
                  v-model="batchCondition.spuPlatFormList"
                  placeholder="请选择配送方式"
                  size="small"
                  filterable
                  class="mr10"
                >
                  <el-option
                    :label="v.platformName"
                    :value="v.platformId"
                    v-for="(v, i) in salesChannels"
                    :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="销售上架">
              <el-form-item label="开售时间">
                <el-date-picker
                  v-model="batchCondition.date"
                  type="datetime"
                  align="right"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择开售时间"
                  size="small"
                  class="mr10"
                ></el-date-picker>
                <div class="form-item-tip">
                  开售商品必须先上架，需商品在指定时间下，才能开售，否则上架状态下，显示开售倒计时
                </div>
              </el-form-item>
              <el-form-item label="上架时间">
                <el-date-picker
                  v-model="batchCondition.date"
                  type="datetime"
                  placeholder="请选择上架时间"
                  align="right"
                  value-format="yyyy-MM-dd"
                  size="small"
                  class="mr10"
                ></el-date-picker>
                <div class="form-item-tip">上架后商品才可销售</div>
              </el-form-item>
              <el-form-item label="下架时间">
                <el-date-picker
                  v-model="batchCondition.date"
                  type="datetime"
                  placeholder="请选择下架时间"
                  align="right"
                  value-format="yyyy-MM-dd"
                  size="small"
                  class="mr10"
                ></el-date-picker>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="商品限购">
              <el-form-item label="每人限购">
                <el-input
                  clearable
                  v-model.trim="searchCondition.keyWords"
                  placeholder
                  size="small"
                  class="ipt"
                ></el-input>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitRuleForm" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small" type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <hm-import-temp
      :tHeader="tHeader"
      :tBody="tBody"
      @close="importTempVisible = false"
      title="商品导入"
      filterText="spuName"
      :visible="importTempVisible"
    ></hm-import-temp>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { outPutMixin } from "@/mixins/outputMixin";
import HmImportTemp from "@/components/HmImportTemp";

export default {
  components: { HmImportTemp },
  mixins: [outPutMixin],
  data() {
    return {
      tHeader: [],
      tBody: [],
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: [],
      batchCondition: {
        oldWord: "",
        newWord: "",
        categoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {},
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false,
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.categoryId) {
      this.searchCondition.categoryId = this.$route.query.categoryId;
    }
    this.tHeader = this.$refs.brandTable.columns
      .map(o => {
        return o.label !== "序号" && o.label !== "操作" && o.label;
      })
      .filter(o => o);
    this.tBody = this.$refs.brandTable.$children
      .map(o => o._props.prop)
      .filter(o => o);
    this.$store.dispatch("querySalesChannels");
    this.queryList();
  },
  computed: mapGetters(["mallGoodsList", "salesChannels", "allMallGoodsList"]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  methods: {
    submitRuleForm() {
      let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
      batchCondition.categoryId =
        batchCondition.categoryId[this.ruleForm.categoryId.length - 1];
      batchCondition.spuIdList = this.checkedRow;
      this.$store.dispatch("batchEdit", batchCondition).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
          this.dialogVisible = false;
        }
      });
    },
    addGoods() {
      this.$router.push({ name: "AddCombGoods" });
    },
    edit(row) {
      this.$router.push({
        name: "EditCombGoods",
        query: {
          spuId: row.spuId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          spuId: row.spuId
        };
        if (type) {
          actionName = "batchEdit";
          params = {
            spuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      Object.assign(params, searchCondition);
      const actionName = queryAll
        ? "queryAllMallGoodsList"
        : "queryMallGoodsList";
      return this.$store.dispatch(actionName, params);
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.remove(this.checkedRow, "batch");
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss">
.micro-goods-list {
  .el-tabs__header {
    background: #f4f4f4;
  }
}
</style>
<style scoped lang="scss">
.table-panel {
  font-size: 12px;
  .line {
    color: #dcdfe6;
    margin: 0 5px;
  }
}
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}

.tabs {
  .first-tip {
    padding-left: 30px;
    margin-bottom: 20px;
    .title {
      padding-left: 0;
    }
  }
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .form-item-tip {
    font-size: 12px;
  }
}
.form-item-tip {
  color: #999;
  font-size: 14px;
}
</style>
